module.exports = __webpack_public_path__ + "img/ctgi-app-icon.688dfd80.png";